export function preloadingEnd(callback) {
  let loadingScreenContainer = document.getElementById('loading-screen');
  let time = 0;
  if (loadingScreenContainer) {
    time = 500;
  }

  setTimeout(() => {
    document.body.classList.add('page-loading--hide');
    document.body.classList.remove('page-loading');
    callback ? callback() : null;
  }, 100);

  setTimeout(() => {
    document.body.classList.remove('page-loading--hide');
  }, time + 100);

  if (loadingScreenContainer) loadingScreenContainer.remove();
  fetch('/preloading', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded', // Możesz zmienić na 'application/json', jeśli to potrzebne
    },
    body: new URLSearchParams({
      preloading: 1,
    }).toString(),
  }).catch(error => {
    console.error('Błąd podczas wysyłania:', error);
  });
}